import { AdmissionEditor } from '../../components/admin/AdmissionEditor';
import './AdmissionForm.css';
import FloatingAlert from '../../components/common/FloatingAlert';
import PrimaryButton from '../../components/common/PrimaryButton';
import { useAdmissionForm } from '../../hooks/useAdmissionForm';
import { FaSave } from 'react-icons/fa';
import { ClimbingBoxLoader } from 'react-spinners';
import { useState } from 'react';

const AdmissionForm = () => {
  const {
    content,
    setContent,
    setBrochureFile,
    admissionLink,
    setAdmissionLink,
    loading,
    alert,
    currentBrochureLink,
    saveAdmissionContent: originalSaveAdmissionContent
  } = useAdmissionForm();

  const [isSaving, setIsSaving] = useState(false);

  const saveAdmissionContent = async () => {
    setIsSaving(true);
    try {
      await originalSaveAdmissionContent();
    } finally {
      setIsSaving(false);
    }
  };

  if (loading) return (
    <div className="admission-form">
      <div className="loading-container">
      <ClimbingBoxLoader color='var(--primary-color)' size={10} />
        {/* <BeatLoader color="var(--primary-color)" /> */}
      </div>
    </div>
  );

  return (
    <div className="admission-form">
      {alert.show && (
        <FloatingAlert message={alert.message} type={alert.type} />
      )}
      <AdmissionEditor
        content={content}
        onChange={setContent}
      />
      <div className="form-group">
        <label>Upload Brosur (PDF):</label>
        {currentBrochureLink && (
          <div className="existing-file-info">
            <span>Brosur Saat Ini: </span>
            <a href={currentBrochureLink} target="_blank" rel="noopener noreferrer">
              Lihat Brosur
            </a>
          </div>
        )}
        <input 
          type="file" 
          accept=".pdf"
          onChange={(e) => setBrochureFile(e.target.files[0])}
        />
      </div>
      <div className="form-group">
        <label>Link Pendaftaran Online:</label>
        <input
          type="text"
          value={admissionLink}
          onChange={(e) => setAdmissionLink(e.target.value)}
          placeholder="Masukkan link pendaftaran"
        />
      </div>
      <PrimaryButton 
        icon={FaSave}
        loading={isSaving}
        onClick={saveAdmissionContent}
      >
        Simpan Perubahan
      </PrimaryButton>
    </div>
  );
};

export default AdmissionForm;
